import React from 'react';
import PropTypes from 'prop-types';

const CloseIcon = (props) => {
  const {
    width, height, fill, className,
  } = props;

  const w = (width) ? width.toString().concat('px') : '12px';
  const h = (height) ? height.toString().concat('px') : '12px';

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      className={(className) ? `icon ${className}` : 'icon'}
      viewBox="0 0 12 12"
      width={w}
      height={h}
    >
      <path
                // eslint-disable-next-line max-len
        d="M1.28033 0.219426C0.987437 -0.0734674 0.512563 -0.0734674 0.21967 0.219426C-0.0732233 0.512319 -0.0732233 0.987193 0.21967 1.28009L4.93976 6.00018L0.22003 10.7199C-0.0728634 11.0128 -0.0728634 11.4877 0.22003 11.7806C0.512923 12.0735 0.987797 12.0735 1.28069 11.7806L6.00042 7.06084L10.7198 11.7802C11.0127 12.0731 11.4876 12.0731 11.7805 11.7802C12.0734 11.4873 12.0734 11.0124 11.7805 10.7196L7.06108 6.00018L11.7808 1.28044C12.0737 0.987549 12.0737 0.512675 11.7808 0.219782C11.4879 -0.0731114 11.0131 -0.0731112 10.7202 0.219782L6.00042 4.93952L1.28033 0.219426Z"
        fill={(fill) || '#FFFFFF'}
      />
    </svg>
  );
};

CloseIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  fill: PropTypes.string,
  className: PropTypes.string,
};

export default CloseIcon;
